/** Préfixe auto « qualification - » pour l’intitulé de fiche (assistant création). */
export const templateIntitulePrefix = (qualification) => {
    if (qualification == null || String(qualification).trim() === "") {
        return "";
    }
    return `${String(qualification).trim()} - `;
};

const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

/**
 * Longueur du préfixe « qual … - … » dans fullName si présent (espaces autour du tiret tolérés).
 * Évite le faux positif où `name` vaut seulement « Qualif - » sans l’espace final attendu par templateIntitulePrefix.
 */
const qualificationPrefixLength = (fullName, qualification) => {
    const qual = String(qualification ?? "").trim();
    if (!qual) return null;
    const full = String(fullName ?? "");
    const re = new RegExp("^" + escapeRegExp(qual) + "\\s*-\\s*");
    const m = full.match(re);
    if (!m) return null;
    return m[0].length;
};

/** Partie saisie libre après le préfixe. */
export const getTemplateIntituleSuffix = (fullName, qualification) => {
    const qual = String(qualification ?? "").trim();
    if (!qual) return fullName ?? "";
    const len = qualificationPrefixLength(fullName, qual);
    if (len == null) return String(fullName ?? "");
    return String(fullName ?? "").slice(len);
};

/** True si l’utilisateur a bien complété l’intitulé (au-delà du seul préfixe auto). */
export const isTemplateIntituleFilled = (templateData) => {
    const qual = templateData?.qualification?.trim() || "";
    if (!qual) return false;
    const raw = String(templateData?.name ?? "");
    if (!raw.trim()) return false;

    const len = qualificationPrefixLength(raw, qual);
    if (len != null) {
        return raw.slice(len).trim().length > 0;
    }
    return raw.trim().length > 0;
};

/**
 * Clé de comparaison d'un nom de fiche : casse et espaces ignorés, pour que
 * « Boucher H/F - Lyon » et « boucher h/f -  lyon » soient le même nom.
 * Doit rester alignée sur normalizeTemplateName côté api.
 */
export const normalizeTemplateName = (name) =>
    String(name ?? "")
        .trim()
        .replace(/\s+/g, " ")
        .toLowerCase();

/** True si une autre fiche active de l'entreprise porte déjà ce nom. */
export const isTemplateNameTaken = (name, templates, currentId) => {
    const wanted = normalizeTemplateName(name);
    if (!wanted) return false;
    return (templates || []).some(
        (template) =>
            !template?.archived &&
            String(template?._id) !== String(currentId) &&
            normalizeTemplateName(template?.name) === wanted
    );
};

/**
 * Nom proposé pour une copie : « … (copie) », puis « (copie 2) », « (copie 3) »…
 * jusqu'au premier libre, pour que le bouton Dupliquer soit actif d'emblée.
 * Le préfixe qualification reste intact : le suffixe est ajouté à la fin.
 */
export const buildDuplicateTemplateName = (name, templates) => {
    const base = String(name ?? "").trim();
    if (!base) return "";
    const candidate = (rank) =>
        rank === 1 ? `${base} (copie)` : `${base} (copie ${rank})`;
    let rank = 1;
    while (isTemplateNameTaken(candidate(rank), templates)) {
        rank += 1;
    }
    return candidate(rank);
};
